// Moving through a list of claims on SingleClaim.vue: AllClaims.vue opens a claim with ?queue=<the list's ids>.
export default {
  watch: {
    "$route.params.id"(newId, oldId) {
      if (newId !== oldId) this.getClaim();
    },
  },
  computed: {
    queueIds() {
      const q = this.$route.query.queue;
      return q ? q.split(",").map(Number) : [];
    },
    queuePosition() {
      return this.queueIds.indexOf(Number(this.$route.params.id));
    },
    nextId() {
      const ids = this.queueIds;
      return this.queuePosition + 1 < ids.length ? ids[this.queuePosition + 1] : null;
    },
    prevId() {
      return this.queuePosition > 0 ? this.queueIds[this.queuePosition - 1] : null;
    },
  },
  methods: {
    goToQueue(id) {
      this.$router.push({ path: `/claim/${id}`, query: this.$route.query });
    },
    // After verifying or vetting, on to the next queued claim rather than back to the list.
    goToNextOrList() {
      if (this.nextId) this.goToQueue(this.nextId);
      else this.$router.push("/all-claims");
    },
  },
};
